/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui';
import React from 'react';
import { Text } from '@theme-ui/components';
import Scrollspy from 'react-scrollspy';
import styled from '@emotion/styled';
import slugger from 'github-slugger';
import { Link } from 'gatsby';
import { typography, colors } from '../../styles/theme';

const Nav = styled('nav')`
  position: sticky;
  top: 96px;
  right: 5vw;
  margin-left: 40px;
  padding-left: 10px;
  max-width: 250px;
  border-left: 1px solid ${colors.neutral200};
`

const StyledScrollSpy = styled(Scrollspy)`
  padding: 0;

  & > li {
    list-style-type: none;
    margin: 10px 3px 0 0;
    padding: 0;
  }

  & > li > a {
    color: ${colors.neutral900};
    text-decoration: none;
    border-bottom: 0;
    transition: 1s all ease-in-out;
  }

  & > li.is-current > a {
    color: ${colors.primaryMain};
    font-weight: bold;
  }
`

export const TOCList = ({ headings }) => {
  let url = headings
    .filter((h) => h.depth == 2)
    .map((heading) => {
      return slugger.slug(heading.value);
    });

  return (
    <Nav>
      <Text sx={{ ...typography.h6 }} as="h3">Table of Contents</Text>
      <StyledScrollSpy offset={-300} items={url} currentClassName='is-current' style={{...typography.textMd500}}>
        {headings
          .filter((h) => h.depth == 2)
          .map((heading, index) => (
            <li key={`h-${index}`}>
              <Link key={`toc-${index}`} to={'#' + slugger.slug(heading.value)}>
                <Text>{heading.value}</Text>
              </Link>
            </li>
          ))}
      </StyledScrollSpy>
    </Nav>
  );
};

export default TOCList;
